import { useState } from 'react';
import MasterItemPicker from '@/components/master/MasterItemPicker';
import { registrationApi } from './registrationApi';
import { useT } from '@/i18n/LanguageContext';

const SRC_LABEL_CLASS = {
  mfg: 'bg-orange-50 text-orange-700 border-orange-200',
  eng: 'bg-teal-50 text-teal-700 border-teal-200',
  it: 'bg-violet-50 text-violet-700 border-violet-200',
  office: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  equip: 'bg-sky-50 text-sky-700 border-sky-200',
};

/**
 * <ItemMasterSearch> — 「まずマスターを探す。無ければ新しく入れる」（仕様 2.1）。
 *
 * 2026-06: **殻は `MasterItemPicker` ひとつ**（標準ルール §7.1 #4）。
 * ここは登録フォーム向けの薄い包み（全台帳を横断で探し、選んだ値を
 * 登録フォームの項目名に写すだけ）。独自の入力欄・候補一覧は持たない。
 */
export const ItemMasterSearch = ({
  onPick, testId = 'item-master-search', label = null, placeholder = null,
}) => {
  const { t } = useT();
  const [picked, setPicked] = useState(null);

  const pick = (r) => {
    setPicked(r);
    onPick?.({
      name: r.name || '', model_no: r.model_no || '', maker: r.maker || '',
      maker_pn: r.maker_pn || '', reference_url: r.reference_url || '',
      source: r.source, source_id: r.id, sku: r.sku || '',
    });
  };

  return (
    <div data-testid={testId}>
      <MasterItemPicker
        testIdPrefix={testId}
        label={label || t('reg.masterSearch')}
        placeholder={placeholder || t('reg.masterSearch.ph')}
        helper={t('reg.masterSearch.hint')}
        search={registrationApi.masterSearch}
        sources={['mfg', 'eng', 'it', 'office', 'equip']}
        minChars={2}
        onPick={pick}
        linked={picked ? {
          label: picked.name, sku: picked.sku, sourceLabel: picked.source_label,
        } : null}
        onUnlink={() => setPicked(null)}
        unlinkLabel="選択を外す"
        renderResultExtra={(r) => (
          <span className={`rounded border px-1.5 text-[10px] font-semibold ${SRC_LABEL_CLASS[r.source] || SRC_LABEL_CLASS.mfg}`}>
            {r.source_label}
          </span>
        )}
      />
    </div>
  );
};

export default ItemMasterSearch;
